import React, { useState } from 'react';
import { ManageUsersPanel } from './SuperAdminPanel';
import { UserSignupForm } from './UserSignupForm';
import { panelAddButtonClass } from './LogoutButton';

export function AddManageUsersPanel({ onBack, createOpen, onCreateOpenChange, user }) {
  const [reloadKey, setReloadKey] = useState(0);

  if (createOpen) {
    return (
      <UserSignupForm
        onBack={() => onCreateOpenChange(false)}
        backLabel="← Back to User/Worker list"
        user={user}
        companyName={user?.company_name || undefined}
        onCreated={() => {
          onCreateOpenChange(false);
          setReloadKey((key) => key + 1);
        }}
      />
    );
  }

  return (
    <ManageUsersPanel
      onBack={onBack}
      reloadKey={reloadKey}
      title="Add / Manage User/Workers"
      description="Manage users and supervisors."
      showHeaderFilters
      titleAction={
        <button
          type="button"
          onClick={() => onCreateOpenChange(true)}
          className={panelAddButtonClass}
        >
          Add User/Worker
        </button>
      }
    />
  );
}
